/**
 * AppInfo - Provides application information from package.json
 */

import packageJson from '../../package.json';

export class AppInfo {
  /**
   * Get the application name
   */
  public static getName(): string {
    return packageJson.name;
  }

  /**
   * Get the application version
   */
  public static getVersion(): string {
    return packageJson.version;
  }

  /**
   * Get the full application title
   */
  public static getFullTitle(): string {
    return `${this.getName()} v${this.getVersion()}`;
  }

  /**
   * Check if running in development mode
   */
  public static isDevelopment(): boolean {
    return import.meta.env.DEV;
  }

  /**
   * Get build mode
   */
  public static getBuildMode(): string {
    return this.isDevelopment() ? 'Development' : 'Production';
  }

  /**
   * Get all app info as an object
   */
  public static getAll(): {
    name: string;
    version: string;
    buildMode: string;
    isDevelopment: boolean;
  } {
    return {
      name: this.getName(),
      version: this.getVersion(),
      buildMode: this.getBuildMode(),
      isDevelopment: this.isDevelopment()
    };
  }
}
